import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, useIntl } from 'react-intl';
import utils from '../../utils/utils';

const RefundCalculatorItem = ({ orderItem, onRefundAmountChange }) => {
  const [resultPrice, setResultPrice] = useState(0);

  const onWeightChange = (newValue) => {
    if (!orderItem.item.priceFields.unitPrice || !newValue || isNaN(newValue)) {
      setResultPrice(0);
      onRefundAmountChange(0);
      return;
    }

    const newValueNumber = Number(newValue);

    const newPrice = newValueNumber * orderItem.item.priceFields.unitPrice;
    const newRefundAmount = utils.getRoundedPrice(newPrice < orderItem.itemPrice ? orderItem.itemPrice - newPrice : 0);
    setResultPrice(newRefundAmount);
    onRefundAmountChange(newRefundAmount);
  };

  const { formatMessage } = useIntl();

  // TODO remove getItemUnitQuantity after order items are being populated
  return (
    <tr>
      <th scope="row">{`${orderItem.itemName}${utils.getItemUnitQuantity(orderItem.item, formatMessage)}`}</th>
      <td>{orderItem.itemPrice}€</td>
      <td>{orderItem.item.priceFields.unitPrice}€</td>
      <td>
        <input className="form-control" type="text" onChange={(event) => onWeightChange(event.target.value)} />
      </td>
      <td>{resultPrice}€</td>
    </tr>
  );
};

RefundCalculatorItem.propTypes = {
  orderItem: PropTypes.object.isRequired,
  onRefundAmountChange: PropTypes.func.isRequired,
};

RefundCalculatorItem.defaultProps = {};

export default injectIntl(RefundCalculatorItem);
